
document.addEventListener('DOMContentLoaded', function() {
    // Close overlay function
    function closeOverlay() {
        document.getElementById('overlay').style.display = 'none';
    }

    // Toggle search component function
    document.getElementById('toggleButton').addEventListener('click', function() {
        var searchComponent = document.querySelector('.head-slot.head-slot-mid');
        searchComponent.classList.toggle('HDM');
    });

    // SVG element click event to simulate link click
    const svgElement = document.querySelector('#closeMenu svg');
    if (svgElement) {
        svgElement.addEventListener('click', function() {
            const linkElement = document.getElementById('link');
            if (linkElement) {
                linkElement.click();
            } else {
                console.error('Link element not found.');
            }
        });
    } else {
        console.error('SVG element not found.');
    }

    // Open overlay function
    function openOverlay() {
        var overlay = document.getElementById('overlay');
        if (overlay.style.display === 'block') {
            overlay.style.display = 'none';
        } else {
            overlay.style.display = 'block';
        }
    }

    // Add click event listener to overlay to close it when clicked
    var overlayElement = document.getElementById('overlay');
    if (overlayElement) {
        overlayElement.addEventListener('click', closeOverlay);
    } else {
        console.error('Overlay element not found.');
    }

    // Expose functions to global scope
    window.closeOverlay = closeOverlay;
    window.openOverlay = openOverlay;


    const searchInput = document.getElementById('header-global-search-input');

  if (searchInput) {
    const searchForm = searchInput.closest('form');

    if (searchForm) {
      searchForm.addEventListener('submit', function(event) {
        let currentValue = searchInput.value.trim();
        if (currentValue !== '' && !currentValue.endsWith('*')) {
          searchInput.value = currentValue + '*';
        }
      });
    }
  }
});





